import { TemplatePortal } from '@angular/cdk/portal';

export interface ActionBarPortalState {
  portal: TemplatePortal<unknown> | null;
  forceLayoutClass: boolean;
}
